import React from 'react';
import Icon from '../../../components/AppIcon';

const IssueCategoryChart = ({ data }) => {
  const colors = [
    'bg-blue-500',
    'bg-green-500',
    'bg-yellow-500',
    'bg-purple-500',
    'bg-red-500',
    'bg-indigo-500',
    'bg-pink-500'
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <Icon name="PieChart" className="w-5 h-5 text-blue-600" />
          Issue Categories
        </h3>
      </div>
      <div className="space-y-4">
        {data?.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <Icon name="PieChart" className="w-12 h-12 text-gray-300 mx-auto mb-2" />
            <p>No category data available</p>
          </div>
        ) : (
          data?.map((category, index) => (
            <div key={index}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-700">{category?.category}</span>
                <span className="text-sm text-gray-600">
                  {category?.count} ({category?.percentage}%)
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className={`h-2 rounded-full ${colors?.[index % colors?.length]}`}
                  style={{ width: `${category?.percentage}%` }}
                />
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default IssueCategoryChart;
